import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
} from 'components/ui/form';
import { Switch } from 'components/ui/switch';
import * as React from 'react';

type SwitchGsProps = {
  label: string;
  description?: string;
  onCheckedChange?(checked: boolean): void;
  checked?: boolean;
};

export const SwitchGs = React.forwardRef<HTMLBaseElement, SwitchGsProps>(
  ({ label, onCheckedChange, checked, description }) => {
    return (
      <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
        <FormLabel className="text-sm font-sans">{label}</FormLabel>
        {description && <FormDescription>{description}</FormDescription>}
        <FormControl>
          <Switch
            checked={checked}
            onCheckedChange={onCheckedChange}
            className="scale-90 !m-0"
          />
        </FormControl>
      </FormItem>
    );
  }
);
